<template>
  <div class="w-full h-full bg-gray-50">
    <div class="max-w-7xl mx-auto px-3 sm:px-4 lg:px-4">
      <div class="text-center py-4 sm:py-6 lg:py-10">
        <h1 class="text-lg sm:text-xl lg:text-3xl font-bold mb-2 sm:mb-3 lg:mb-4">
          {{ t('qualityDelivery.title') }}
        </h1>
        <p class="text-gray-600 mb-6 sm:mb-8 lg:mb-12 text-xs sm:text-sm lg:text-base px-2">
          {{ t('qualityDelivery.subtitle') }}
        </p>

        <!-- Navigation - 移动端可滚动 -->
        <div class="mb-6 sm:mb-8 lg:mb-16">
          <div class="flex justify-center lg:space-x-12 overflow-x-auto scrollbar-hide">
            <div class="flex space-x-4 sm:space-x-6 lg:space-x-12 min-w-max px-2 lg:px-0">
              <button
                v-for="(tab, index) in tabs"
                :key="index"
                @click="activeTabIndex = index"
                :class="[
                  'whitespace-nowrap pb-1 sm:pb-2 transition-colors duration-200 text-xs sm:text-sm lg:text-base',
                  activeTabIndex === index
                    ? 'text-green-700 border-b-2 border-green-700'
                    : 'text-gray-500 hover:text-green-600'
                ]"
              >
                {{ t(`qualityDelivery.tabs[${index}].name`) }}
              </button>
            </div>
          </div>
        </div>

        <!-- Main Content -->
        <div class="flex flex-col lg:flex-row items-center gap-4 sm:gap-6 lg:gap-16">
          <!-- Left Side - Stack Image -->
          <div class="w-full lg:w-1/2 order-2 lg:order-1">
            <div
              class="relative h-[200px] sm:h-[280px] lg:h-[500px] bg-gradient-to-br from-green-100 to-green-50 rounded-lg sm:rounded-xl lg:rounded-2xl p-3 sm:p-4 lg:p-8 flex items-center justify-center"
            >
              <img
                :src="backgroundImg"
                alt="Eco Solutions Stack"
                class="w-full h-full object-contain"
              />
            </div>
          </div>

          <!-- Right Side - Content -->
          <div class="w-full lg:w-1/2 text-center lg:text-left order-1 lg:order-2 px-2 lg:px-0">
            <h2 class="text-base sm:text-lg lg:text-3xl font-bold mb-3 sm:mb-4 lg:mb-6">
              {{ t(`qualityDelivery.tabs[${activeTabIndex}].title`) }}
            </h2>
            <p class="text-gray-600 mb-4 sm:mb-6 lg:mb-8 leading-relaxed text-xs sm:text-sm lg:text-base">
              {{ t(`qualityDelivery.tabs[${activeTabIndex}].description`) }}
            </p>

            <!-- Solution Cards -->
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-3 lg:gap-4">
              <div
                v-for="(feature, featureIndex) in 4"
                :key="featureIndex"
                class="bg-green-700 p-3 sm:p-4 lg:p-6 rounded-md sm:rounded-lg text-white hover:bg-green-800 transition-colors duration-200 cursor-pointer touch-manipulation"
                @touchstart=""
              >
                <h3 class="font-medium leading-relaxed text-xs sm:text-sm lg:text-base">
                  {{
                    t(
                      `qualityDelivery.tabs[${activeTabIndex}].features[${featureIndex}]`
                    )
                  }}
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { ref, computed } from 'vue'
  import { useI18n } from 'vue-i18n'
  import backgroundImg from '../../../assets/other/9427787283e1044bab90.png'

  const { t, locale } = useI18n()
  const activeTabIndex = ref(0)

  const tabs = ref([
    { name: '解决方案' },
    { name: '指导' },
    { name: '质量与交付' },
    { name: '透明度' }
  ])

  // 获取当前标签页的特性列表
  const getCurrentFeatures = () => {
    const features = t(`qualityDelivery.tabs[${activeTabIndex.value}].features`)
    console.log(features)
    // 确保返回的是数组，如果不是数组则返回空数组
    return Array.isArray(features) ? features : []
  }
  getCurrentFeatures()
</script>

<style scoped>
  .bg-green-700 {
    background-color: #2f5c45;
  }

  .bg-green-800 {
    background-color: #1f3a2e;
  }

  .transition-colors {
    transition-property: color, background-color, border-color;
  }

  /* 隐藏滚动条但保持滚动功能 */
  .scrollbar-hide {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  
  .scrollbar-hide::-webkit-scrollbar {
    display: none;
  }

  /* 移动端触摸优化 */
  @media (max-width: 1024px) {
    .touch-manipulation {
      touch-action: manipulation;
    }
    
    .bg-green-700:active {
      background-color: #1f3a2e;
      transition: background-color 0.1s ease;
    }
  }
</style>
